import { AxiosPendencyAPI } from "../Api";
import { Icon, Label, Loader, Popup, Table } from "semantic-ui-react";
import { ErrorSegment } from "../../common/components/ErrorSegment";
import React from "react";
import { PendencyEmployee } from "./PendencyEmployee";
import { NoRecords } from "../../common/components/NoRecords";
import { Icons } from "../../common/Icons";
import { PaginationButtons } from "../../common/components/PaginationButtons";
import { useQueryWithPagination } from "../../utils/Hooks";

const PendencyStatus = ({ status, reason }) => {
  const labels = {
    pending: { text: "Pendente", color: null },
    canceled: { text: "Cancelado", color: null },
    accepted: { text: "Aceito", color: "green" },
    rejected: { text: "Rejeitado", color: "red" },
  };

  if (status === "rejected") {
    return (
      <Popup
        flowing
        trigger={
          <Label color={labels[status].color}>
            {labels[status].text}
            <Label.Detail>
              <Icon name={"info circle"} />
            </Label.Detail>
          </Label>
        }
      >
        <Popup.Header>Justificativa</Popup.Header>
        <Popup.Content>{reason}</Popup.Content>
      </Popup>
    );
  }

  return <Label color={labels[status].color}>{labels[status].text}</Label>;
};

export const PendencyDoneList = () => {
  const { data, isPending, error, handleNext, handlePrevious } =
    useQueryWithPagination({
      queryKey: ["pendency-done-list"],
      queryFn: AxiosPendencyAPI.getAll,
      pending: false,
    });
  if (isPending) return <Loader active />;
  if (error) return <ErrorSegment message={error.message} />;

  return (
    <>
      <PendencyDoneTable data={data} isPending={isPending} error={error} />
      <PaginationButtons
        previous={data?.previous}
        next={data?.next}
        onPrevious={handlePrevious}
        onNext={handleNext}
      />
    </>
  );
};

export const PendencyDoneTable = ({ data }) => {
  if (!data) return;
  if (data.results.length === 0)
    return (
      <NoRecords
        iconName={Icons.ALL_DONE}
        message={"Não existem pendências finalizadas!"}
      />
    );

  let rows = data.results.map((pendency) => (
    <Table.Row key={pendency.id}>
      <Table.Cell>
        <PendencyEmployee employee={pendency.requester_employee} />
      </Table.Cell>
      <Table.Cell>
        <PendencyEmployee employee={pendency.target} />
      </Table.Cell>
      <Table.Cell>
        <PendencyEmployee employee={pendency.new_manager} />
      </Table.Cell>
      <Table.Cell>{pendency.change_date.format()}</Table.Cell>
      <Table.Cell>
        <PendencyStatus status={pendency.status} reason={pendency.reason} />
      </Table.Cell>
    </Table.Row>
  ));

  return (
    <Table selectable padded="very">
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell>Requerente</Table.HeaderCell>
          <Table.HeaderCell>Funcionário</Table.HeaderCell>
          <Table.HeaderCell>Novo gestor</Table.HeaderCell>
          <Table.HeaderCell>Data de mudança</Table.HeaderCell>
          <Table.HeaderCell>Status</Table.HeaderCell>
        </Table.Row>
      </Table.Header>
      <Table.Body>{rows}</Table.Body>
    </Table>
  );
};
